
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, FileText, PackageCheck } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

// Mock data
const restockData = [
  {
    id: 1,
    name: "Organic Brown Rice 1kg",
    currentQty: 8,
    threshold: 10,
    reorderQty: 20,
    leadTime: 3,
    autoEnabled: true
  },
  {
    id: 2,
    name: "Fresh Milk 1L",
    currentQty: 5,
    threshold: 15,
    reorderQty: 30,
    leadTime: 1,
    autoEnabled: true
  },
  {
    id: 3,
    name: "Whole Wheat Bread",
    currentQty: 6,
    threshold: 10,
    reorderQty: 15,
    leadTime: 1,
    autoEnabled: false
  },
  {
    id: 4,
    name: "Free-Range Eggs (Dozen)",
    currentQty: 4,
    threshold: 8,
    reorderQty: 12,
    leadTime: 2,
    autoEnabled: true
  },
  {
    id: 5,
    name: "Instant Coffee 200g",
    currentQty: 3,
    threshold: 5,
    reorderQty: 10,
    leadTime: 4,
    autoEnabled: true
  }
];

const AutoRestockTab = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [autoRestockItems, setAutoRestockItems] = useState<number[]>(
    restockData.filter(item => item.autoEnabled).map(item => item.id)
  );
  
  const filteredRestockData = restockData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const toggleAutoRestock = (id: number) => {
    if (autoRestockItems.includes(id)) {
      setAutoRestockItems(autoRestockItems.filter(itemId => itemId !== id));
    } else {
      setAutoRestockItems([...autoRestockItems, id]);
    }
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Auto-Restock</h2>
        <div className="flex gap-2">
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search products..."
              className="pl-8 w-[250px]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button>
            <PackageCheck className="mr-2 h-4 w-4" />
            Generate Purchase Order
          </Button>
        </div>
      </div>
      
      <div className="border rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Product Name</TableHead>
              <TableHead className="text-center">Current Qty</TableHead>
              <TableHead className="text-center">Threshold</TableHead>
              <TableHead className="text-center">Suggested Reorder</TableHead>
              <TableHead className="text-center">Lead Time (days)</TableHead>
              <TableHead className="text-center">Auto-Restock</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredRestockData.map((item) => (
              <TableRow key={item.id} className={item.currentQty <= item.threshold ? "bg-yellow-50" : ""}>
                <TableCell className="font-medium">{item.name}</TableCell>
                <TableCell className="text-center">
                  <span className={item.currentQty <= item.threshold ? "text-red-600 font-medium" : ""}>
                    {item.currentQty}
                  </span>
                </TableCell>
                <TableCell className="text-center">{item.threshold}</TableCell>
                <TableCell className="text-center">{item.reorderQty}</TableCell>
                <TableCell className="text-center">{item.leadTime}</TableCell>
                <TableCell className="text-center">
                  <Checkbox 
                    checked={autoRestockItems.includes(item.id)}
                    onCheckedChange={() => toggleAutoRestock(item.id)}
                  />
                </TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="outline">Edit</Button>
                  <Button size="sm" className="ml-2">Order Now</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default AutoRestockTab;
